import { useMemo } from 'react'

import { isEmpty } from 'lodash'

import { useChainModal } from '@rainbow-me/rainbowkit'

import { useAirdropState } from 'hooks/airdrop'
import { useIsWrongChainId } from 'hooks/wallet'

import { useAirdropParams, useRecipientsList, useBigintExceptionsList } from 'state/airdrop/hooks'

import { CHAIN_INFO } from 'constants/chains'

import { Notification } from 'components/ui'
import { BalanceError } from 'components/features'

// ToDo replace
import { Stats } from '../AirdropForm/Stats'
import { Statuses } from '../AirdropForm/@types'

import { Exceptions } from './Exceptions'
import { Recipients } from './Recipients'
import { RefundInfo } from '../RefundInfo'

import { Section } from './Style'

export function ApprovalForm() {
  const { openChainModal } = useChainModal()

  const airdropState = useAirdropState()
  const airdropParams = useAirdropParams()
  const isWrongChainId = useIsWrongChainId()

  const recipientsList = useRecipientsList()
  const exceptionsList = useBigintExceptionsList()

  const isEmulationFailed = useMemo(() => {
    return exceptionsList.length === recipientsList.length
  }, [exceptionsList.length, recipientsList.length])

  const onOpenChainChangeModal = () => {
    if (openChainModal) {
      openChainModal()
    }
  }

  const isExceptionStep = useMemo(() => !isEmpty(exceptionsList), [exceptionsList])

  const isBalanceError = useMemo(() => {
    return !isWrongChainId && (!airdropState.isTokensBalanceEnough || !airdropState.isBalanceEnough)
  }, [isWrongChainId, airdropState.isTokensBalanceEnough, airdropState.isBalanceEnough])

  return (
    <>
      <Stats status={[Statuses.TOTAL_TOKENS_TO_SEND, Statuses.TOKEN_BALANCE]} layout='approval' />

      <Section>
        {isWrongChainId && (
          <Notification
            isClickable
            type='error'
            margin='0 auto 1.6rem'
            onClick={onOpenChainChangeModal}
            message={`Currently, airdrop is available only on ${
              CHAIN_INFO[airdropParams.airdropChainId].name
            }. Change network to continue`}
          />
        )}

        {isBalanceError && <BalanceError />}

        {isExceptionStep ? (
          <Exceptions isEmulationFailed={isEmulationFailed} exceptions={exceptionsList} />
        ) : (
          <Recipients isBalanceError={isBalanceError} />
        )}
        <RefundInfo />
      </Section>
    </>
  )
}
